import _ from 'lodash';
import moment from 'moment';
import { showToast } from '../utils';
import { constructUrl } from '../utils/api';

const { client } = require('../services/api-client');

const addExtraDay = date => {
  return date ? moment(date).add(1, 'days').format('YYYY-MM-DD') : '';
};

const getTherapistsRatingReport = async (_resource, params) => {
  try {
    const { filters, pagination } = params;
    filters.dateUpper = addExtraDay(filters.dateUpper);
    const url = constructUrl(`report/therapist/rating`, {
      filters,
      pagination,
    });
    const resp = await client(url, { authNeeded: true });
    return {
      data: resp.items,
      total: resp.count,
    };
  } catch (err) {
    showToast('Error in getReportList - tip', 'error');
    return Promise.reject(err);
  }
};

const getTipsReport = async (_resource, params) => {
  try {
    const { filters, pagination } = params;
    filters.dateUpper = addExtraDay(filters.dateUpper);
    const url = constructUrl(`report/therapist/tips`, {
      filters,
      pagination,
    });
    const resp = await client(url, { authNeeded: true });
    const final_resp = resp?.items && resp.items.filter(t => t.sum > 0);
    final_resp.push({
      full_name: 'Total',
      id: '11',
      sum: resp.totalSum,
    });
    return {
      data: final_resp,
      total: { total: resp.count, sum: resp.totalSum },
    };
  } catch (err) {
    showToast('Error in getReportList - tip', 'error');
    return Promise.reject(err);
  }
};

const getHallSqueezersReport = async (_resource, params) => {
  try {
    const { filters, pagination } = params;
    const url = constructUrl(`report/appointment/count`, {
      filters,
      pagination,
    });
    const resp = await client(url, { authNeeded: true });
    return {
      data: resp.items,
      total: resp.count,
    };
  } catch (err) {
    showToast('Error in getReportList - tip', 'error');
    return Promise.reject(err);
  }
};

const getScoreboardReport = async (_resource, params) => {
  try {
    const { filters } = params;
    filters.dateUpper = addExtraDay(filters.dateUpper);
    const url = constructUrl(`report/scorecard`, {
      filters,
      pagination: false,
    });
    const resp = await client(url, { authNeeded: true });
    return {
      data: resp.items,
      total: resp.count,
    };
  } catch (err) {
    showToast('Error in getReportList - tip', 'error');
    return Promise.reject(err);
  }
};

const getCancelMembershipReportList = async (_resource, params) => {
  try {
    const { filters, pagination } = params;
    filters.dateUpper = addExtraDay(filters.dateUpper);
    const url = constructUrl(`report/membership/cancel`, {
      filters,
      pagination,
    });
    const resp = await client(url, { authNeeded: true });
    const sortByCancellation =
      resp &&
      _.sortBy(resp?.items, item =>
        item.cancel_effective_at || item.cancelled_at || item.membership_end,
      );
    return {
      data: sortByCancellation,
      total: resp.count,
    };
  } catch (err) {
    showToast('Error in getReportList - tip', 'error');
    return Promise.reject(err);
  }
};

const getGiftsReport = async (_resource, params) => {
  try {
    const { filters } = params;
    const { location_id } = filters;
    filters.redeemedAtUpper = addExtraDay(filters.redeemedAtUpper);
    filters.purchaseDateUpper = addExtraDay(filters.purchaseDateUpper);
    let url = '';
    if (location_id === 'all') {
      delete filters.location_id;
      url = constructUrl(`report/user/gifts`, {
        filters,
        pagination: false,
      });
    } else {
      url = constructUrl(`report/user/gifts`, {
        filters,
        pagination: false,
      });
    }
    const resp = await client(url, { authNeeded: true });
    return {
      data: resp.items,
      total: resp.count,
    };
  } catch (err) {
    showToast('Error in getReportList - tip', 'error');
    return Promise.reject(err);
  }
};

const getPromoRevenueReport = async (_resource, params) => {
  try {
    const { filters } = params;
    filters.txnDateUpper = addExtraDay(filters.txnDateUpper);
    const url = constructUrl(`report/promo/revenue`, {
      filters,
      pagination: false,
    });
    const resp = await client(url, { authNeeded: true });
    return {
      data: resp.items,
      total: resp.count,
    };
  } catch (err) {
    showToast('Error in getReportList - tip', 'error');
    return Promise.reject(err);
  }
};

const getDistributionReport = async (_resource, params) => {
  try {
    const { filters } = params;
    filters.dateUpper = addExtraDay(filters.dateUpper);
    const url = constructUrl(`report/distribution`, {
      filters,
      pagination: false,
    });
    const resp = await client(url, { authNeeded: true });
    return {
      data: resp.items,
      total: resp.count,
    };
  } catch (err) {
    showToast('Error in getReportList - Distribution', 'error');
    return Promise.reject(err);
  }
};

const getSqueezeBucksRevenueReport = async (_resource, params) => {
  try {
    const { filters } = params;
    const url = constructUrl(`report/user/wallet`, {
      filters,
      pagination: false,
    });
    const resp = await client(url, { authNeeded: true });
    let _resp = [];
    _resp.push({
      id: resp['id'],
      name: 'Squeeze Bucks Balance',
      value: resp['totalSum'],
    });
    return {
      data: _resp,
      total: null,
    };
  } catch (err) {
    showToast('Error in getReportList - tip', 'error');
    return Promise.reject(err);
  }
};

const getCrossLocationAdjustmentReport = async (_resource, params) => {
  try {
    const { filters, pagination } = params;
    filters.dateUpper = addExtraDay(filters.dateUpper);
    const url = constructUrl(`report/membership-cross-location`, {
      filters,
      pagination: false,
    });
    const resp = await client(url, { authNeeded: true });
    return {
      data: resp,
      total: resp.length,
    };
  } catch (err) {
    showToast('Error in getReportList - Membership-cross-location', 'error');
    return Promise.reject(err);
  }
};

const getMembersReport = async (_resource, params) => {
  try {
    const { filters, pagination } = params;
    filters.dateUpper = addExtraDay(filters.dateUpper);
    const url = constructUrl(`report/membership`, {
      filters,
      pagination,
    });
    const resp = await client(url, { authNeeded: true });
    return {
      data: resp.items,
      total: resp.count,
    };
  } catch (err) {
    showToast('Error in getReportList - tip', 'error');
    return Promise.reject(err);
  }
};

const exportMembersReport = async (_resource, params) => {
  try {
    const { filters } = params;
    filters.dateUpper = addExtraDay(filters.dateUpper);
    const url = constructUrl(`report/membership`, {
      filters,
      pagination: false,
    });
    const resp = await client(url, { authNeeded: true });
    return resp
  } catch (err) {
    showToast(err?.message || 'Error in export report - Member', 'error');
    return Promise.reject(err);
  }
};

const getPromosReport = async (_resource, params) => {
  try {
    const { filters } = params;
    const url = constructUrl(`report/promo`, {
      filters,
      pagination: false,
    });
    const resp = await client(url, { authNeeded: true });
    return {
      data: resp.items,
      total: resp.count,
    };
  } catch (err) {
    showToast('Error in getReportList - Promo', 'error');
    return Promise.reject(err);
  }
};

const exportPromosReport = async (_resource, params) => {
  try {
    const { filters } = params;
    const url = constructUrl(`report/promo`, {
      filters,
      pagination: false,
    });
    const resp = await client(url, { authNeeded: true });
    return resp
  } catch (err) {
    showToast(err?.message || 'Error in export report - Promo', 'error');
    return Promise.reject(err);
  }
};

const getDemosReport = async (_resource, params) => {
  try {
    const { filters, pagination } = params;
    filters.dateUpper = addExtraDay( filters.dateUpper );
    const url = constructUrl( `report/demo`, {
      filters,
      pagination,
    });
    const resp = await client(url, { authNeeded: true });
    return {
      data: resp.items,
      total: resp.count,
    };
  } catch (err) {
    showToast('Error in getReportList - Demos', 'error');
    return Promise.reject(err);
  }
};

const exportDemosReport = async (_resource, params) => {
  try {
    const { filters } = params;
    const url = constructUrl(`report/demo`, {
      filters,
      pagination: false,
    });
    const resp = await client(url, { authNeeded: true });
    return resp
  } catch (err) {
    showToast(err?.message || 'Error in export report - Promo', 'error');
    return Promise.reject(err);
  }
};

const getPaymentsReport = async (_resource, params) => {
  try {
    const { filters } = params;
    filters.dateUpper = addExtraDay(filters.dateUpper);
    const url = constructUrl(`report/payment`, {
      filters,
      pagination: false,
    });
    const resp = await client(url, { authNeeded: true });
    return resp;
  } catch (err) {
    showToast('Error in getReportList - Payments', 'error');
    return Promise.reject(err);
  }
};

const getGuestMarketingReport = async (_resource, params) => {
  try {
    const { filters, pagination } = params;
    filters.dateUpper = addExtraDay(filters.dateUpper);
    const url = constructUrl(`report/marketing/guest-export`, {
      filters: { ...filters, csv: false },
      pagination,
    });
    const resp = await client(url, { authNeeded: true });
    return {
      data: resp.items || [],
      total: resp.count || 0,
    };
  } catch (err) {
    showToast('Error in getGuestMarketingReport', 'error');
    return Promise.reject(err);
  }
};

const exportGuestMarketingReport = async (_resource, params) => {
  try {
    const { filters = {}, pagination } = params;
    
    // Build filters object - always include offset and limit
    const exportFilters = { ...filters };
    
    // Set offset: use from filters, pagination, or default to 0
    exportFilters.offset = 
      (filters?.offset !== undefined && filters?.offset !== null) 
        ? filters.offset 
        : (pagination?.offset !== undefined && pagination?.offset !== null)
          ? pagination.offset
          : 0;
    
    // Set limit: use from filters or pagination (include if provided, otherwise backend decides)
    if (filters?.limit !== undefined && filters?.limit !== null) {
      exportFilters.limit = filters.limit;
    } else if (pagination?.limit !== undefined && pagination?.limit !== null) {
      exportFilters.limit = pagination.limit;
    }
    // If limit not specified, it won't be in filters - backend will use its default
    
    const url = constructUrl(`report/marketing/guest-export`, {
      filters: exportFilters,
      pagination: false,
    });
    const resp = await client(url, { authNeeded: true });
    return resp;
  } catch (err) {
    showToast(err?.message || 'Error in export report - Guest Marketing', 'error');
    return Promise.reject(err);
  }
};

export {
  getTherapistsRatingReport,
  getTipsReport,
  getScoreboardReport,
  getHallSqueezersReport,
  getCancelMembershipReportList,
  getGiftsReport,
  getPromoRevenueReport,
  getSqueezeBucksRevenueReport,
  getDistributionReport,
  getCrossLocationAdjustmentReport,
  getMembersReport,
  exportMembersReport,
  getPromosReport,
  exportPromosReport,
  getDemosReport,
  exportDemosReport,
  getPaymentsReport,
  getGuestMarketingReport,
  exportGuestMarketingReport
};
